import {
  START_LOADING_CONTRACT,
  CONTRACT_LOAD_SUCCESS,
  CONTRACT_LOAD_FAILED,
  CONTRACT_LOAD_SKIPPED,
  CONTRACT_CREATE_SUCCESS,
  CONTRACT_UPDATE_SUCCESS
} from '../actions/types';

const initialState = {
  loadingContract: false,
  contracts: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case START_LOADING_CONTRACT:
      return {
        ...state,
        loadingContract: true
      };
    case CONTRACT_LOAD_SUCCESS:
      return {
        ...state,
        loadingContract: false,
        contracts: [...payload]
      };
    case CONTRACT_LOAD_FAILED:
    case CONTRACT_LOAD_SKIPPED:
      return {
        ...state,
        loadingContract: false
      };
    case CONTRACT_CREATE_SUCCESS:
      console.log(payload)
      return {
        ...state,
        contracts: [payload, ...state.contracts]
      };
    case CONTRACT_UPDATE_SUCCESS:
      return {
        ...state,
        contracts: state.contracts.map(v => {
          if (v._id === payload._id) {
            return payload;
          }
          return v;
        })
      };
    default:
      return state;
  }
};
